module.exports = __webpack_public_path__ + "img/FARGO-584x584.4fc25e67.webp";